import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-historique-menu-popover',
  templateUrl: './historique-menu-popover.component.html',
  styleUrls: ['./historique-menu-popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HistoriqueMenuPopoverComponent {
  @Input() showVideoPlayback = false;

  constructor(
    private popoverCtrl: PopoverController,
    private router: Router,
  ) {}

  async navigate(path: string) {
    await this.popoverCtrl.dismiss({ path });
    this.router.navigate([path]);
  }
}
